import { FuseNavigationItem } from '@fuse/components/navigation';
import {
    compactNavigation,
    defaultNavigation,
    futuristicNavigation,
    horizontalNavigation,
} from 'app/core/navigation/navigation.data';
import { Navigation } from 'app/core/navigation/navigation.types';
import { cloneDeep } from 'lodash-es';

/**
 * Fills the children of the top level items of a navigation with the matching items
 * (same id) of the default navigation.
 */
function withChildrenFromDefault(items: FuseNavigationItem[]): FuseNavigationItem[]
{
    const result = cloneDeep(items);

    result.forEach((item) =>
    {
        defaultNavigation.forEach((defaultItem) =>
        {
            if ( defaultItem.id === item.id )
            {
                item.children = cloneDeep(defaultItem.children);
            }
        });
    });

    return result;
}

/**
 * Builds the navigation of the app for all layouts. Returns fresh copies on every call.
 */
export function buildNavigation(): Navigation
{
    return {
        compact   : withChildrenFromDefault(compactNavigation),
        default   : cloneDeep(defaultNavigation),
        futuristic: withChildrenFromDefault(futuristicNavigation),
        horizontal: withChildrenFromDefault(horizontalNavigation),
    };
}
